import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AppShell from './components/layout/AppShell';
import HomePage from './components/HomePage';
import Dashboard from './components/Dashboard';
import LoginPage from './components/LoginPage';
import ComingSoon from './components/ComingSoon';
import { LoadProvider } from './components/loadContext';
import { QuotesBookingsProvider } from './components/quotes/QuotesBookingsContext';
import QuotesAndBookings from './components/quotes/QuotesAndBookings';
import ProtectedRoute from './ProtectedRoute';
import QuickCreateShipmentAction from './components/shipments/QuickCreateShipmentAction';
import LoadWorkspacePage from './components/loadboard/LoadWorkspacePage';
import './App.css';

function App() {
  const shellAction = <QuickCreateShipmentAction />;
  return (
    <LoadProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<ComingSoon title="Create your workspace" description="Self-service sign up is on the way. In the meantime, contact your FreightLogic representative to provision access." />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AppShell
                  pageTitle="Operations Control Center"
                  pageSubtitle="A live command hub for every load, milestone, and client interaction."
                  actionArea={shellAction}
                >
                  <Dashboard />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/loads/:id"
            element={
              <ProtectedRoute>
                <AppShell pageTitle="Shipment workspace" pageSubtitle="Live execution and documents for this load.">
                  <LoadWorkspacePage />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/shipments"
            element={
              <ProtectedRoute>
                <AppShell pageTitle="Shipments" pageSubtitle="Search, filter, and orchestrate every load across your network.">
                  <ComingSoon title="Shipments workspace" description="A unified manifest of active, upcoming, and historical loads will be available here." />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings"
            element={
              <ProtectedRoute>
                <QuotesBookingsProvider>
                  <AppShell pageTitle="Quotes & Bookings" pageSubtitle="Real-time quoting and commitment tracking across your network.">
                    <QuotesAndBookings />
                  </AppShell>
                </QuotesBookingsProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path="/carriers"
            element={
              <ProtectedRoute>
                <AppShell pageTitle="Carrier Network" pageSubtitle="Curate your preferred partners and monitor performance in real time.">
                  <ComingSoon title="Carrier profiles" description="Deep carrier dossiers, scorecards, and onboarding workflows are coming soon." />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts"
            element={
              <ProtectedRoute>
                <AppShell pageTitle="Accounts Payable" pageSubtitle="Stay ahead of settlements, documents, and carrier pay cycles.">
                  <ComingSoon title="Accounts Payable" description="Invoice reconciliation, approvals, and payment automation will live here." />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stats"
            element={
              <ProtectedRoute>
                <AppShell pageTitle="Analytics" pageSubtitle="Executive dashboards and predictive insights to power better decisions.">
                  <ComingSoon title="Analytics" description="Advanced forecasting, margin tracking, and SLA monitoring dashboards are under construction." />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <AppShell pageTitle="Workspace settings" pageSubtitle="Control access, branding, and integrations from one secure hub.">
                  <ComingSoon title="Settings" description="Team management, integrations, and branding controls are being redesigned." />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admindash"
            element={
              <ProtectedRoute>
                <AppShell pageTitle="Administrator" pageSubtitle="Proactive tooling for platform operators and implementation teams.">
                  <ComingSoon title="Admin Console" description="Deep configuration, tenant analytics, and automation scripting will reside here." />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="*"
            element={
              <AppShell pageTitle="Page missing" pageSubtitle="The route you tried to access does not exist yet.">
                <ComingSoon title="Let's get you back on track" description="Use the navigation to explore existing workspaces." />
              </AppShell>
            }
          />
        </Routes>
      </Router>
    </LoadProvider>
  );
}

export default App;
